import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';

import Page from '../shared/Page';
import SaveButton from '../shared/SaveButton';
import CancelButton from '../shared/CancelButton';
import KeywordsSection from '../shared/KeywordsSection';
import Loader from '../shared/Loader';
import RichEditor from '../shared/RichEditor';
import SectionTitle from '../shared/SectionTitle';
import SectionDescription from '../shared/SectionDescription';
import LabeledToggle from '../shared/LabeledToggle';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import { notifyError, notifyInfo } from '../../utils/notifier';
import { getBreadCrumbs } from '../../utils/breadCrumbs';
import withEulaRestrictions from '../license/withEulaRestrictions';
import { ADMINS } from '../../constants/userRoles';
import { PAGE_PATHS, REPORT_MANAGEMENT } from '../../constants/pathsRoots';
import {
  fetchEmailTemplateKeywords,
  fetchReportOptions,
  updateReportOptions,
} from '../../actions/companies/apiRequests';

const KEYWORDS_DESCRIPTION = `You can use the keywords below in the cover letter. Sample values will be replaced with the real test info.`;

class CoverLetterLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isIncluded: true,
      loading: false,
      saving: false,
      keywords: [],
      editorContent: '',
      initContentOfEditor: '',
      reportOptions: {},
    };

    this.onEditorChange = this.onEditorChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.setIsIncluded = this.setIsIncluded.bind(this);
  }

  static get propTypes() {
    return {
      history: PropTypes.object,
      match: PropTypes.object,
      uom: PropTypes.string,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const keywords = fetchEmailTemplateKeywords(match.params.companyId).then((keywords) => {
      fetchReportOptions(match.params.companyId).then(({ coverLetter, includeCoverLetter, ...res }) => {
        this.setState({
          loading: false,
          keywords: keywords,
          editorContent: coverLetter,
          initContentOfEditor: coverLetter || '',
          isIncluded: includeCoverLetter,
          reportOptions: res,
        });
      });
    });
  }

  actions() {
    const { saving } = this.state;
    const {
      match: {
        params: { companyId },
      },
    } = this.props;

    return [
      <CancelButton
        key="cancel"
        onClick={() => {
          this.props.history.push({
            pathname: '/reports',
            state: {
              companyId,
            },
          });
        }}
      />,
      <SaveButton key="save" onClick={this.onSave} loading={saving} disabled={saving} />,
    ];
  }

  onSave() {
    const { match, uom } = this.props;
    const { reportOptions, editorContent, isIncluded } = this.state;
    this.setState({ saving: true });

    updateReportOptions(match.params.companyId, {
      ...reportOptions,
      coverLetter: editorContent,
      includeCoverLetter: isIncluded,
      unitOfMeasure: uom,
    })
      .then(() => {
        notifyInfo();
        this.setState({ saving: false });
      })
      .catch((error) => {
        notifyError(error.message);
        this.setState({ saving: false });
      });
  }

  onEditorChange(value) {
    this.setState({
      editorContent: value,
    });
  }

  setIsIncluded(value) {
    this.setState({
      isIncluded: value,
    });
  }

  render() {
    const { isIncluded, initContentOfEditor, loading, keywords } = this.state;
    return (
      <Page
        header="Edit Official Report Cover Letter"
        description="The settings on this page will be included each time the report template is generated"
        actions={this.actions()}
        breadCrumbs={getBreadCrumbs('Edit Report', location.pathname, [PAGE_PATHS[REPORT_MANAGEMENT]])}
      >
        <Row>
          <Col md={8}>
            <div className="mb-3">
              <SectionTitle title="Cover Letter" />
              <SectionDescription description="This text will display on the front page of this report" />
              <LabeledToggle
                label="Include Cover Letter"
                checked={isIncluded}
                onChange={() => this.setIsIncluded(!isIncluded)}
              />
            </div>
            <RichEditor initValue={initContentOfEditor} onChange={this.onEditorChange} />
            <SectionDescription className="mt-2" description="Only images uploaded from your local drive can be displayed in reports" />
          </Col>
          <Col md={4} className="">
            {loading ? <Loader /> : <KeywordsSection description={KEYWORDS_DESCRIPTION} data={keywords} />}
          </Col>
        </Row>
      </Page>
    );
  }
}

const mapStateToProps = ({ profile }) => ({
  uom: profile.uom,
});

export default connect(mapStateToProps)(withEulaRestrictions(withRoleRestrictions(CoverLetterLayout, ADMINS)));



// WEBPACK FOOTER //
// src/components/coverLetterLayout/CoverLetterLayout.jsx